export function classifyHS(description) {
    const desc = (description || "").toLowerCase();

    if (desc.includes("toy")) return { hsCode: "9503.00.00", dutyRate: 5 };
    if (desc.includes("shirt") || desc.includes("textile") || desc.includes("clothing")) return { hsCode: "6109.10.00", dutyRate: 5 };
    if (desc.includes("phone") || desc.includes("electronics")) return { hsCode: "8517.12.00", dutyRate: 0 };
    if (desc.includes("furniture") || desc.includes("chair") || desc.includes("table") || desc.includes("wood")) return { hsCode: "9403.00.00", dutyRate: 5 };

    // Default general classification mapping
    return { hsCode: "8479.89.90", dutyRate: 5 };
}

export function calculateLandedCost(estimatedValue, dutyRate) {
    const value = parseFloat(estimatedValue) || 0;
    const rate = parseFloat(dutyRate) || 0;

    const duty = value * (rate / 100);
    const gst = (value + duty) * 0.10;
    const landedCost = value + duty + gst;

    return {
        customsDuty: parseFloat(duty.toFixed(2)),
        gst: parseFloat(gst.toFixed(2)),
        landedCost: parseFloat(landedCost.toFixed(2))
    };
}
